<template>
  <v-card style="border-radius: 1em;" class="pa-2">
    <v-card-title>
      <v-btn icon @click="$emit('fechar')">
        <v-icon>close</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <h1>Configurações de Taxas</h1>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap justify-space-around fill-height v-if="!loading && !carregando">
        <v-flex xs12 class="p">
          <v-text-field
            v-model.lazy="checktudo.taxa_completa"
            label="Taxa Completa"
            outlined
            hide-details
            v-money="money"
            prefix="R$"
            class="mb-3"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model.lazy="checktudo.taxa_essencial"
            label="Taxa Essencial"
            outlined
            hide-details
            v-money="money"
            prefix="R$"
            class="mb-3"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model.lazy="checktudo.taxa_leilao"
            label="Taxa Leilão"
            outlined
            hide-details
            v-money="money"
            prefix="R$"
            class="mb-3"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model.lazy="checktudo.taxa_gravame"
            label="Taxa Gravame"
            outlined
            hide-details
            v-money="money"
            prefix="R$"
            class="mb-3"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model.lazy="checktudo.taxa_cadastrais"
            label="Taxa Cadastrais"
            outlined
            hide-details
            v-money="money"
            prefix="R$"
            class="mb-3"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model.lazy="checktudo.taxa_multas"
            label="Taxa Multas"
            outlined
            hide-details
            v-money="money"
            prefix="R$"
            class="mb-3"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 class="d-flex align-center mt-3">
          <v-btn color="primary" @click="salvar">
            Salvar
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout justify-center v-else>
        <v-progress-circular
          indeterminate
          :size="100"
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money'

export default {
  directives: { money: VMoney },
  data: () => ({
    checktudo: {
      id: null,
      taxa_completa: '0,00',
      taxa_essencial: '0,00',
      taxa_leilao: '0,00',
      taxa_gravame: '0,00',
      taxa_cadastrais: '0,00',
      taxa_multas: '0,00'
    },
    money: {
      decimal: ',',
      thousands: '.',
      precision: 2,
      masked: false
    },
    carregando: false
  }),
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    salvar () {
      const taxasFormatadas = {
        taxa_completa: this.checktudo.taxa_completa === '0,00' ? null : this.checktudo.taxa_completa.replace(',', '.'),
        taxa_essencial: this.checktudo.taxa_essencial === '0,00' ? null : this.checktudo.taxa_essencial.replace(',', '.'),
        taxa_leilao: this.checktudo.taxa_leilao === '0,00' ? null : this.checktudo.taxa_leilao.replace(',', '.'),
        taxa_gravame: this.checktudo.taxa_gravame === '0,00' ? null : this.checktudo.taxa_gravame.replace(',', '.'),
        taxa_cadastrais: this.checktudo.taxa_cadastrais === '0,00' ? null : this.checktudo.taxa_cadastrais.replace(',', '.'),
        taxa_multas: this.checktudo.taxa_multas === '0,00' ? null : this.checktudo.taxa_multas.replace(',', '.')
      }
      if (this.checktudo.id) {
        this.$store.dispatch('atualizarTaxaChecktudo', taxasFormatadas)
          .then(() => {
            this.listarTaxas()
            this.$emit('success', 'As taxas foram atualizadas com sucesso!')
          }).catch(() => {
            this.$emit('error', 'Erro ao tentar atualizar taxas.')
          })
      } else {
        this.$store.dispatch('criarTaxaChecktudo', taxasFormatadas)
          .then(() => {
            this.listarTaxas()
            this.$emit('success', 'As taxas foram criadas com sucesso!')
          }).catch(() => {
            this.$emit('error', 'Erro ao tentar criar taxas.')
          })
      }
    },
    async listarTaxas () {
      this.carregando = true
      await this.$store.dispatch('listarTaxasChecktudo')
        .then(json => {
          if (json) {
            this.checktudo = {
              id: json.id ? json.id : null,
              taxa_completa: json.taxa_completa ? json.taxa_completa : null,
              taxa_essencial: json.taxa_essencial ? json.taxa_essencial : null,
              taxa_leilao: json.taxa_leilao ? json.taxa_leilao : null,
              taxa_gravame: json.taxa_gravame ? json.taxa_gravame : null,
              taxa_cadastrais: json.taxa_cadastrais ? json.taxa_cadastrais : null,
              taxa_multas: json.taxa_multas ? json.taxa_multas : null
            }
          }
      })
      .catch(() => {
            console.log('Nenhuma taxa foi encontrada.')
      })
      this.carregando = false
    }
  },
  mounted () {
    this.listarTaxas()
  }
}
</script>
